<template>
  <v-app>
    <v-container>
      <div class="row justify-content-between">
        <div class="col">
          <h1 class="h3 mb-2 text-center text-gray-800">Улирлын шалгалтууд</h1>
        </div>
      </div>
      <v-row>
        <v-col cols="12" md="8" lg="8">
          <v-card
            flat
            class="mb-4"
            v-for="semester in semesters"
            v-bind:key="semester.id"
          >
            <v-card-title
              >{{ semester.title }}
              <span v-if="semester && semester.lessons != null"></span>({{
                semester.lessons.length
              }})
            </v-card-title>
            <shalgaltuud-table :xpath="semester.ref.path" :lessons="semester.lessons"> </shalgaltuud-table>
          </v-card> 
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import ShalgaltuudTable from "./ShalgaltuudTable";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      semesters: null,
    };
  },
  components: {
    ShalgaltuudTable,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _addShalgalt(semester) {},
  },
  created() {
    fb.db
      .collection("semester")
      .orderBy("index", "desc")
      .get()
      .then((semestersSnapshot) => {
        this.semesters = [];
        semestersSnapshot.forEach((semesterDoc) => {
          let semester = semesterDoc.data();
          semester.id = semesterDoc.id;
          semester.ref = semesterDoc.ref;
          fb.db
            .collection("lessons").orderBy('name','asc')
            .where("semester", "==", semester.ref)
            .onSnapshot((querySnapshot1) => {
              semester.lessons = [];
              querySnapshot1.forEach((lessonDoc) => {
                let lesson = lessonDoc.data();
                lesson.id = lessonDoc.id;
                lesson.ref = lessonDoc.ref;
                semester.lessons.push(lesson);
              });

              this.semesters.push(semester);
            });

          semester.ref.collection("exams").onSnapshot((querySnapshot) => {
            semester.shalgaltuud = [];
            querySnapshot.forEach((doc) => {
              let shalgalt = doc.data();
              shalgalt.id = doc.id;
              shalgalt.ref = doc.ref;
              semester.shalgaltuud.push(shalgalt);
            });
          });
        });
      });
  },

  filters: {},
};
</script>
